import React from 'react';
import KaroakeOrderInvoiceView from './KaraokeOrderFormView3InvoiceView';
import KaraokeOrderPriceInfo from './KaraokeOrderPriceInfo';
import CustomButton from '../../../common/components/CustomButton';

type KaraokeOrderFormView3FieldName =
  'royalty_order'|'already_entrusted'|'title'|'title_kana'|
  'artist_name'|'artist_name_kana'|'lyric_writer_name'|'composer_name'|'applicant_name'|
  'use_vocal_synthesizer'|'vocal_synthesizer_name'|
  'physical'|'onvocal'|'duet'|'intro_click'|'payment_method'|'coupon_code'|'use_balance';

export default function KaraokeOrderFormView3({
  getValue,
  paymentAmount,
  billingAmount,
  discountAmount,
  hasNonAppliedInitialOrderCoupon,
  view,
  priceInfo,
  onBack,
  onNext,
} : {
  getValue: (name: KaraokeOrderFormView3FieldName) => string,
  paymentAmount: number,
  billingAmount: number,
  discountAmount: number,
  hasNonAppliedInitialOrderCoupon: boolean,
  view: string,
  priceInfo: KaraokeOrderPriceInfo,
  onNext: () => void,
  onBack: () => void,
}) {
  const topRef = React.useRef(null);
  React.useEffect(() => {
    if (view === 'view3') {
      (topRef.current as HTMLElement|null)?.scrollIntoView();
    }
  }, [view]);

  const contents = (
    <>
      <form className="cake_ajax_form" ref={topRef}>
        <div className="form page">
          <h2>確認画面</h2>
          <p className="info">間違いはない？お申込み内容を確認してください！</p>
          <h2>曲の情報</h2>
          <div className="inner">
            <div>
              <table className="prices_table" style={{ marginBottom: '60px' }}>
                <tbody>
                  <tr>
                    <th>曲名：</th>
                    <td>{getValue('title')}</td>
                  </tr>
                  <tr>
                    <th>曲名読み（ひらがな）：</th>
                    <td>{getValue('title_kana')}</td>
                  </tr>
                  <tr>
                    <th>アーティスト名：</th>
                    <td>{getValue('artist_name')}</td>
                  </tr>
                  <tr>
                    <th>
                      アーティスト名読み
                      <br className="sp" />
                      （ひらがな）：
                    </th>
                    <td>{getValue('artist_name_kana')}</td>
                  </tr>
                  <tr>
                    <th>作詞者名：</th>
                    <td>{getValue('lyric_writer_name')}</td>
                  </tr>
                  <tr>
                    <th>作曲者名：</th>
                    <td>{getValue('composer_name')}</td>
                  </tr>
                  <tr>
                    <th>申込者名（あなたのお名前）：</th>
                    <td>{getValue('applicant_name')}</td>
                  </tr>
                  {getValue('use_vocal_synthesizer') === '1' && (
                    <tr>
                      <th>キャラクター名：</th>
                      <td>{getValue('vocal_synthesizer_name')}</td>
                    </tr>
                  )}
                  <tr>
                    <th>
                      既にJASRACなどの
                      <br />
                      著作権管理団体に信託済み：
                    </th>
                    <td>{getValue('already_entrusted') === '1' ? 'はい' : 'いいえ'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <h2>お支払い</h2>
          <div className="inner">
            <div>
              <KaroakeOrderInvoiceView
                getValue={getValue}
                paymentAmount={paymentAmount}
                billingAmount={billingAmount}
                discountAmount={discountAmount}
                hasNonAppliedInitialOrderCoupon={hasNonAppliedInitialOrderCoupon}
                priceInfo={priceInfo}
                style={{ marginBottom: '40px' }}
              />
            </div>
            <ul className="form_bt">
              <li className="bt">
                <CustomButton type="cancel-split" onClick={() => onBack()}>戻る</CustomButton>
                <CustomButton type="default-split" onClick={() => onNext()}>申込む</CustomButton>
              </li>
            </ul>
          </div>
        </div>
      </form>
    </>
  );
  return (
    <article>
      <section className="form page">
        <div className="inner">
          {contents}
        </div>
      </section>
    </article>
  );
}
